module.exports = __webpack_public_path__ + "media/images/pepsi-logo-dce744bc2d7ffaeb2b33fc37d91253b8.svg";